import { CARD_TYPE_MAP, PAYMENT_GATEWAY_MAP } from "@shared/constants/enums";
import { UserBasedUserPaymentMethodSerializer } from "@app-contexts/user/features/profile/data/types/payment-types";

import { PaymentServiceBasket } from "../../services/useBasketPaymentService";
import { YunoCheckoutSessionPaymentMethod } from "../../types/yuno";

/**
 * Checks if a basket's payment_gateway can be considered to be of type Yuno
 */
export function isYunoBasketGateway(basket: PaymentServiceBasket) {
  return Boolean(
    basket.paymentGateway &&
      basket.paymentGateway.gateway_type === PAYMENT_GATEWAY_MAP.GATEWAY_YUNO.id
  );
}
/**
 * Transforms a Yuno checkout session payment method into the
 * UserBasedUserPaymentMethodSerializer shape used by the shared
 * CardPaymentTypeSavedCard component.
 *
 * Fields with no Yuno equivalent (id, billing_address, stripe_*,
 * payment_gateway_id, etc.) are left undefined.
 */

export function transformYunoToUserPaymentMethod(
  yunoPaymentMethod: YunoCheckoutSessionPaymentMethod
): UserBasedUserPaymentMethodSerializer {
  return {
    card_last4: yunoPaymentMethod.card_data?.lfd,
    card_type: yunoPaymentMethod.card_data?.brand as CardTypeId | undefined,
    exp_month: yunoPaymentMethod.card_data?.expiration_month,
    exp_year: yunoPaymentMethod.card_data?.expiration_year,
    name_on_card: yunoPaymentMethod.name,
  };
}
export type CardTypeId =
  (typeof CARD_TYPE_MAP)[keyof typeof CARD_TYPE_MAP]["id"];
